export const isValidName = (value: string) => {
    if (value) {
        return true;
    }
    return false;
};

export const isValidPhoneNumber = (value: string) => {
    if (!value.match(/^\+(?:[(]?([0-9])[)]?[- ]?){6,14}[0-9]$/)) {
        return false;
    }
    return true;
};

export const isValidPassword = (value: string) => {
    if (value.length < 6) {
        return false;
    }
    return true;
};

export const isValidAccessCodeLength = (value: string) => {
    if (value.length !== 6) {
        return false;
    }
    return true;
};

export const isAlphanumerical = (value: string) => {
    if (!value.match(/^[a-zA-Z0-9]*$/)) {
        return false;
    }
    return true;
};
